"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.getSubdomain =
  exports.getHostSubdomain =
  exports["default"] =
  exports.buildUrl =
  exports.buildQueryString =
    void 0;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * Retorna o subdomínio de um host (URL sem a parte do protocolo)
 * https://developer.mozilla.org/en-US/docs/Web/API/Location/host
 *
 * @param {string} host
 * @returns {(string|null)}
 */
var _getHostSubdomain = function getHostSubdomain(host) {
  if (host) {
    var match = host.match(/([a-z0-9|-]+)/);
    if (match) {
      return match[0];
    }
  }
  return null;
};
exports.getHostSubdomain = _getHostSubdomain;

/**
 * Retorna o subdomínio de uma URL
 *
 * @param {string} url
 * @returns {(string|null)}
 */
var _getSubdomain = function getSubdomain(url) {
  var host = url.replace("https", "").replace("http", "").replace("://", "");
  return _getHostSubdomain(host);
};
exports.getSubdomain = _getSubdomain;

/**
 * Retorna uma url montada com os dados do env
 *
 * @param {object} param0
 * @returns {(string|null)}
 */
var _buildUrl = function buildUrl(_ref, _ref2) {
  var _ref$subdomain = _ref.subdomain,
    subdomain = _ref$subdomain === void 0 ? null : _ref$subdomain,
    path = _ref.path,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? null : _ref$query;
  var protocol = _ref2.protocol,
    rootDomain = _ref2.rootDomain,
    baseUrl = _ref2.baseUrl;
  var queryString = query ? _buildQueryString(query) : "";
  if (typeof path === "undefined") {
    return subdomain
      ? ""
          .concat(protocol, "://")
          .concat(subdomain, ".")
          .concat(rootDomain)
          .concat(queryString)
      : "".concat(baseUrl).concat(queryString);
  }
  var _char = "/";
  var re = new RegExp("^".concat(_char, "+"));
  path = path.replace(re, "");
  return subdomain
    ? ""
        .concat(protocol, "://")
        .concat(subdomain, ".")
        .concat(rootDomain, "/")
        .concat(path)
        .concat(queryString)
    : "".concat(baseUrl, "/").concat(path).concat(queryString);
};
exports.buildUrl = _buildUrl;

/**
 * Retorna uma query string montada a partir de um objeto
 *
 * @param {object} queryObj
 * @returns {string}
 */
var _buildQueryString = function buildQueryString(queryObj) {
  return Object.keys(queryObj)
    .reduce(function (query, key, i) {
      return ""
        .concat(query)
        .concat(key, "=")
        .concat(encodeURIComponent(queryObj[key]), "&");
    }, "?")
    .slice(0, -1);
};
exports.buildQueryString = _buildQueryString;
var UrlHelper = /*#__PURE__*/ (function () {
  function UrlHelper(_ref3) {
    var _ref3$protocol = _ref3.protocol,
      protocol = _ref3$protocol === void 0 ? "https" : _ref3$protocol,
      rootDomain = _ref3.rootDomain,
      baseUrl = _ref3.baseUrl;
    _classCallCheck(this, UrlHelper);
    this.protocol = protocol;
    this.rootDomain = rootDomain;
    this.baseUrl = baseUrl;
  }
  var _proto = UrlHelper.prototype;
  _proto.buildQueryString = function buildQueryString(queryObj) {
    return _buildQueryString(queryObj);
  };
  _proto.buildUrl = function buildUrl(_ref4) {
    var _ref4$subdomain = _ref4.subdomain,
      subdomain = _ref4$subdomain === void 0 ? null : _ref4$subdomain,
      path = _ref4.path,
      _ref4$query = _ref4.query,
      query = _ref4$query === void 0 ? null : _ref4$query;
    return _buildUrl(
      {
        subdomain: subdomain,
        path: path,
        query: query,
      },
      {
        protocol: this.protocol,
        rootDomain: this.rootDomain,
        baseUrl: this.baseUrl,
      }
    );
  };
  _proto.getSubdomain = function getSubdomain(url) {
    return _getSubdomain(url);
  };
  _proto.getHostSubdomain = function getHostSubdomain(host) {
    return _getHostSubdomain(host);
  };
  return _createClass(UrlHelper);
})();
exports["default"] = UrlHelper;
